<template>
  <span v-for="(rating, index) in Array(5).fill('')" v-bind:key="'rating-' + index" class="me-2"
    @click="ratingChanged(index)">
    <span v-if="index + 1 <= ratingCount" class="fas fa-medium-size fa-star text-warning"></span>
    <span v-else class="fas fa-medium-size fa-star text-primary25"></span>
  </span>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ ratingCount?: number }>(), { ratingCount: 0 });
const emit = defineEmits<{ onRatingChanged: [rating: number] }>();
const ratingChanged = (rating: number) => emit("onRatingChanged", rating + 1);
</script>
